import { Injectable } from "@angular/core";
import { BaseModel } from "./base-model";
import { HttpService } from "../../services/http.service";
import { HttpResponse } from "@angular/common/http";

@Injectable()
export class ConfigJsonModelService extends BaseModel {
	public configData: any;
	constructor(private httpService: HttpService) {
		super();
	}
	public initialize(data: any) {
		this.loadConfigJSON(data);
	}
	private loadConfigJSON(url) {
		this.httpService.get(url).then((res: HttpResponse<any>) => {
			this.parseConfigJSON(res.body);
			//this._notifier.next('data');
		});
	}
	private parseConfigJSON(data) {
		this.configData = data;
		this._notifier.next(data);
		// console.log("parseConfigJSON ",this.configData);
	}
}
